export const AppName = {
    /**大工程师 */
    BigEngineer: 'BigEngineer',
    /**大工程师企业版 */
    BigEngineerE: 'BigEngineerEnterprise',
    /**客源宝 */
    KYBao: 'KYBao',
    /**大国工匠 */
    GreatCraftsman: 'GreatCraftsman',
    /**大国工匠（农机版） */
    GreatCraftsmanNj: 'GreatCraftsmanNj',
    /**大国工匠企业版 */
    GreatCraftsmanEnt: 'GreatCraftsmanEnt',
    GreatCraftsmanInEnt: 'GreatCraftsmanInEnt',
    GreatCraftsmanInJgEnt: 'GreatCraftsmanInJgEnt',
    /**国家装备制造业数字供应链平台-大国智造 */
    GreatIM: 'GreatIM',
    /**国家装备制造业数字供应链公共服务平台-大国工匠 */
    Dggj: 'dggj',
    /**国家装备制造业数字供应链公共服务平台-大国工匠企业版 */
    DggjEnt: 'dggjEnt',
    /**国家装备制造业数字供应链平台-大国智造 */
    Dgzz: 'dgzz',
    ENV: 'engineer_env',
};
export const AppNameText = {
    [AppName.BigEngineer]: '大工程师',
    [AppName.BigEngineerE]: '大工程师企业版',
    [AppName.KYBao]: '客源宝',
    [AppName.GreatCraftsman]: '大国工匠',
    [AppName.GreatCraftsmanNj]: '大国工匠',
    [AppName.GreatCraftsmanEnt]: '大国工匠企业版',
    [AppName.GreatIM]: '大国智造',
    [AppName.Dggj]: '大国工匠',
    [AppName.DggjEnt]: '大国工匠企业版',
    [AppName.Dgzz]: '大国智造',
    [AppName.GreatCraftsmanInEnt]: '大国工匠行业版',
    [AppName.GreatCraftsmanInJgEnt]: "大国工匠激光行业版"
};
export const AppClientDownPath = {
    [AppName.Dggj]: 'https://down.global-dsc.cn/Release/dggj/dggj.exe',
    [AppName.DggjEnt]: 'https://down.global-dsc.cn/Release/dggje/dggjEnt.exe',
    [AppName.Dgzz]: 'https://down.global-dsc.cn/Release/dgzz/dgzz.exe',
    [AppName.GreatCraftsmanInEnt]: 'https://down.global-dsc.cn/Release/dggje/dggjEnt.exe',
    [AppName.GreatCraftsmanInJgEnt]: 'https://down.global-dsc.cn/Release/dggjJd/dggjInJgEnt.exe',
};
